import { ModuleWithProviders, NgModule } from '@angular/core';
import { GetReceiptsLibraryComponent } from './get-receipts-library.component';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';
import { BaseSubmitPetitionLibraryService } from 'base-submit-petition-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';

@NgModule({
  declarations: [GetReceiptsLibraryComponent],
  imports: [
    PrimengLibraryModule,
    StepStatusUpdateComponentLibraryModule,
    FileUploadLibraryModule,
    LastUpdateLibraryModule,
    AssigningTaskLibraryModule,
    MaximizeDialogLibraryModule
  ],
  providers: [BaseSubmitPetitionLibraryService],
  exports: [GetReceiptsLibraryComponent]
})
export class GetReceiptsLibraryModule {
}


